<template>
<div>
  <div class="nav-pagination">
    <div class="container">
      <hr class="hraing" />
      <div class="row">
        <div class="col-md-6 col-sm-6">
          <div class="sooper-text">
            <h4>Contact</h4>
          </div>
        </div>
        <div class="col-md-6 col-sm-6 text-right nav-pagination1">
          <ul>
            <li>
              <a href="index.html">Company</a>
            </li>
            <li>|</li>
            <li>Contact</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="container blog">
    <div class="column">
      <div class="col-md-7">
        <div class="row">
          <div class="col-md-12">
            <div class="blog-text wow animated slideInUp">
              <h4>Contact Form</h4>
              <p class="contact-text">Use the form below to enquire about your project, ask us a question or just say hello!</p>
              <div class="wow animated slideInLeft">
                <div id="mc_embed_signup">
                  <form name="home-newsletter" method="post" data-netlify="true" data-netlify-honeypot="bot-field" class="validate" target="_blank" novalidate>
                    <input type="hidden" name="form-name" value="contact" />
                    <div id="mc_embed_signup_scroll">
                      <div class="input-aling contact-form">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="contact-input">
                              <div class="mc-field-group">
                                <input type="text" placeholder="Name" name="name" class="form-control input-box" id="email" />
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="contact-input">
                              <div class="mc-field-group">
                                <input type="email" name="email" placeholder="Email address" class="form-control input-box required email" id="email" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="big-size">
                          <div class="mc-field-group" id="comment">
                            <textarea class="form-control input-box" name="message" rows="6" placeholder="Write your message here." id="message"></textarea>
                          </div>
                        </div>
                        <div class="row">
                          <div class="mc-field-group">
                            <div class="form-check">
                              <p class="contact-text-privacy">Discovr Analytics is committed to protecting and respecting your privacy, and we’ll only use your personal information to administer your account and to provide the products and services
                                you requested from us. From time to time, we would like to contact you about our products and services, as well as other content that may be of interest to you. If you consent to us contacting you for this purpose,
                                please tick below to say how you would like us to contact you:</p>
                              <input type="checkbox" name="privacy" class="form-check-input" id="privacy" />
                              <label class="form-check-label" for="privacy">I agree to receive other communications from Discovr Analytics.</label>
                              <p class="contact-text-privacy">
                                You can unsubscribe from these communications at any time. For more information on how to unsubscribe, our privacy practices, and how we are committed to protecting and respecting your privacy, please review our
                                <router-link to="/Privacy">
                                  <a>Privacy Policy.</a>
                                </router-link>By clicking submit below, you consent to allow Discovr Analytics to store and process the personal information submitted above to provide you the content requested.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="button-left">
                          <div class="clear">
                            <input type="submit" value="Send Message" name="subscribe" id="mc-embedded-subscribe" class="btn send-message" @click="conversion()" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
    <div class="column">
      <div class="col-md-5">
        <div class="blog-text wow animated slideInUp">
          <img src="../image/office.jpg" class="img-responsive img-contact" />
          <h4>Our Offices</h4>
          <p class="blog-para">
            50/60 Station Road,
            <br />Cambridge,
            <br />CB1 2JH, UK
          </p>
        </div>
        <br />
        <div class="blog-text main-3-section unoorder wow animated slideInUp">
          <h4>Follow Us</h4>
          <center>
            <ul>
              <li class="twitter-icon">
                <a href="#">
                  <i class="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </li>
              <li class="twitter-icon">
                <a href="#">
                  <i class="fa fa-linkedin" aria-hidden="true"></i>
                </a>
              </li>
              <li class="twitter-icon">
                <a href="#">
                  <i class="fa fa-instagram" aria-hidden="true"></i>
                </a>
              </li>
              <li class="twitter-icon">
                <a href="#">
                  <i class="fa fa-twitter" aria-hidden="true"></i>
                </a>
              </li>
            </ul>
          </center>
        </div>
        <br />
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "Contact",
  metaInfo: {
    meta: [{
      name: "description",
      content: "Contact form and details for Discovr Analytics, an analytics consulting and development company."
    }],
    htmlAttrs: {
      lang: "en"
    },
    title: "Contact Us",
    // override the parent template and just use the above title only
    titleTemplate: null
  },
  data: function() {
    return {
      scrolled: true
    };
  },
  beforeDestroy() {
    window.analytics.page("Contact");
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../css/font-awesome.min.css';
</style>
